import React from "react";

const FirmaDocumentoGenericoCrearContext = React.createContext();

export default FirmaDocumentoGenericoCrearContext;